<template>
  <div class="sub-menu-desktop">
    <div class="sub-menu-desktop__items">
      <a
        v-for="(item, i) in result.items"
        :key="i"
        :href="item.href"
        class="sub-menu-desktop__item"
      >
        <DefImg :result="item.image" class="sub-menu-desktop__image" />
        <span class="sub-menu-desktop__name">
          {{ item.name }}
        </span>
      </a>
    </div>
    <div class="sub-menu-desktop__bottom">
      <DefButtonSecondary :href="result.href">
        {{ result.title }}
      </DefButtonSecondary>
    </div>
  </div>
</template>

<script>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';

export default {
  name: 'SubMenuDesktop',
  components: {
    DefButtonSecondary,
    DefImg,
  },
  props: ['result'],
};
</script>

<style lang="scss" scoped>
.sub-menu-desktop {
  position: absolute;
  width: 100%;
  left: 0;
  padding-top: 40px;
  z-index: 3;
  background-color: #fff;
  &__image {
    margin-bottom: 16px;
  }
  &__name {
    font-weight: 600;
    font-size: rem(12);
    text-transform: uppercase;
    line-height: 125%;
  }
  &__items {
    @extend %container;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 24px 16px;
    margin-bottom: 16px;
  }
  &__item {
    display: block;
  }
  &__bottom {
    @extend %container;
    display: flex;
    justify-content: center;
    padding-bottom: 32px;
  }
  &__link {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: rem(14);
    line-height: 100%;
    color: var(--color-dark-grey);
  }
  &__icon {
    display: block;
    width: 14px;
    height: 14px;
    fill: var(--background-dark-grey);
    margin-left: 6px;
  }
  :deep(.def-button-secondary) {
    @include point-md {
      font-size: 16px;
      font-weight: 600;
      padding: 0 18px;
      text-transform: uppercase;
      height: 44px;
    }
  }
}
</style>
